/**
 * Generato automaticamente.
 * framework-geocoding
 */
import { useMutation } from 'react-query';
import type { UseMutationOptions, MutationFunction } from 'react-query';
import type {
  GeojsonExtraDataDTO,
  PostShapefileGeojsonConversioniBody,
} from '.././schemas';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const postShapefileGeojsonConversioni = (
  postShapefileGeojsonConversioniBody: PostShapefileGeojsonConversioniBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  if (postShapefileGeojsonConversioniBody.file !== undefined) {
    postShapefileGeojsonConversioniBody.file.forEach(value =>
      formData.append('file', value),
    );
  }

  return apiClientRequest<GeojsonExtraDataDTO>(
    {
      url: `/framework-geocoding/shapefile-geojson-conversioni`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostShapefileGeojsonConversioniMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postShapefileGeojsonConversioni>>,
    TError,
    { data: PostShapefileGeojsonConversioniBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postShapefileGeojsonConversioni>>,
  TError,
  { data: PostShapefileGeojsonConversioniBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postShapefileGeojsonConversioni>>,
    { data: PostShapefileGeojsonConversioniBody }
  > = props => {
    const { data } = props ?? {};

    return postShapefileGeojsonConversioni(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostShapefileGeojsonConversioniMutationResult = NonNullable<
  Awaited<ReturnType<typeof postShapefileGeojsonConversioni>>
>;
export type PostShapefileGeojsonConversioniMutationBody =
  PostShapefileGeojsonConversioniBody;
export type PostShapefileGeojsonConversioniMutationError = ErrorType<unknown>;

export const usePostShapefileGeojsonConversioni = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postShapefileGeojsonConversioni>>,
    TError,
    { data: PostShapefileGeojsonConversioniBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostShapefileGeojsonConversioniMutationOptions(options);

  return useMutation(mutationOptions);
};
